import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter} from 'react-router-dom';
// import './index.css';
import './assets/css/font-awesome.min.css';
import App from './App';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import * as serviceWorker from './serviceWorker';
import * as actionTypes from './store/actions/actionTypes'
import loginReducer from './store/reducers/login';
import newPasswordReducer from './store/reducers/newPasssword';
import forgotPasswordReducer from './store/reducers/forgotPassword';
import dashboardReducer from './store/reducers/dashboard';
import gcpDashboardReducer from './store/reducers/gcpDashboard';
import settingsReducer from './store/reducers/accountSettings';
import installationReducer from './store/reducers/installation';
import xogroupsReducer from './store/reducers/xogroups';
import schedulerReducer from './store/reducers/scheduler';
import budgetReducer from './store/reducers/budget';
import alertsReducer from './store/reducers/alerts';

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const appReducer = combineReducers({
    login: loginReducer,
    newPassword: newPasswordReducer,
    forgotPassword: forgotPasswordReducer,
    dashboard: dashboardReducer,
    gcpDashboard: gcpDashboardReducer,
    settings: settingsReducer,
    installation: installationReducer,
    xogroups: xogroupsReducer,
    scheduler: schedulerReducer,
    budget: budgetReducer,
    alerts: alertsReducer,
});

const rootReducer = (state, action) => {
    if (action.type === actionTypes.LOGOUT_SUCCESS) {
        state = undefined
    }

    return appReducer(state, action)
};

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
